import { googleApiClient } from '$utils/apiClient'
import { rawAddressToModel } from '$domain/model/map/map.mapper'
import { apiErrorService } from '$utils/services/apiErrorService'

export const getAddressFromLocation = async (latitude: number, longitude: number) => {
  try {
    const googlePostalAddressResult = await googleApiClient.get<{
      results: {}[]
      status: string
    }>(`/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY_SERVER}`)
    if (googlePostalAddressResult.status !== 'ZERO_RESULTS') {
      return rawAddressToModel(googlePostalAddressResult.results[0])
    }
    return undefined
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/map/map.respositoy.ts